import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLink} from 'apollo-link-http';
import {onError} from 'apollo-link-error';
import {ApolloLink} from 'apollo-link';
import {authLogout} from 'App/util/redux/auth/actions';

import settings from 'Root/settings.json';

import * as helper from 'App/util/common/helper';
import {timerRefreshRequest} from 'App/util/redux/autoLogout/actions';
import {applicationStore as store} from 'App/index';

const onErrorLink = onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors) {
    graphQLErrors.map(({message, locations, path}) => {
        if (helper.DEV_MODE) {
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          );
        }

        // logout if permission denied error
        // FIXME: filter correctly if sub0 error format changes
        if (message == undefined || message.includes('permission denied')) {
          store.dispatch(authLogout(helper.cb_autoLogout));
        }
      }
    );
  }

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const httpLink = new HttpLink({
  uri: settings.graphql.uri,
  credentials: 'same-origin'
});

const refreshTimerMiddleware = new ApolloLink((operation, forward) => {
  store.dispatch(timerRefreshRequest());

  return forward(operation);
});

const client = new ApolloClient({
  link: ApolloLink.from([
    onErrorLink,
    refreshTimerMiddleware,
    httpLink
  ]),
  cache: new InMemoryCache()
});

export default client;


// WEBPACK FOOTER //
// ./src/util/graphql/client.js